import React, { useMemo } from "react";
import { Field, reduxForm } from "redux-form";

import Button from "@material-ui/core/Button";
import Loading from "../../../components/Loading";
import useStyles from "./styles";
import { useTranslation } from "react-i18next";

const renderField = ({ input, meta, ...rest }) => {
	return (
		<div>
			<input value={input.value} onChange={input.onChange} {...rest} />
			{meta.touched && meta.error && <div>{meta.error}</div>}
		</div>
	);
};

let TableForm = (props) => {
	const classes = useStyles();
	const { t } = useTranslation();
	const { handleSubmit } = props;
	const validators = useMemo(() => {
		const required = (val) => (!val ? t("validation.required") : null);
		const isNumber = (val) =>
			val !== undefined && val !== "" && Number(val) < 5
				? t("loadControl.minNumber")
				: null;

		return [required, isNumber];
	}, [t]);

	return (
		<div className={classes.root}>
			<form onSubmit={props.handleSubmit} initialValues={props.initialValues}>
				<div className={classes.workTimeWrap}>
					<div className={classes.labelWrap}>
						<label>{t("loadControl.deliveryInterval")}</label>
					</div>
					<Field
						className={classes.calendarField}
						name="orderTimeIntervalDelivery"
						component={renderField}
						type="number"
						placeholder=""
						label=""
						validate={validators}
					/>
				</div>

				<div className={classes.workTimeWrap}>
					<div className={classes.labelWrap}>
						<label>{t("loadControl.pickupInterval")}</label>
					</div>
					<Field
						className={classes.calendarField}
						name="orderTimeIntervalPickup"
						component={renderField}
						type="number"
						placeholder=""
						label=""
						validate={validators}
					/>
				</div>

				<Button
					onClick={handleSubmit}
					className={classes.button}
					disabled={props.preloader ? true : false}
					variant="contained"
					color="primary"
				>
					{props.preloader ? <Loading size={22} color={"#fff"} /> : t("common.save")}
				</Button>
			</form>
		</div>
	);
};

TableForm = reduxForm({
	form: "WorkingHours",
	enableReinitialize: true,
})(TableForm);

export default TableForm;
